import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import {
  CreateOnboardingTemplate,
  DeleteOnboardingConfiguration,
  OnboardingChargingStation,
  OnboardingConfiguration,
  OnboardingTemplate,
  UpdateChargingStationFromTemplate,
  UpdateOnboardingTemplate
} from './model';
import { ComponentGroup } from '@infuse/api/cpms/operator';

const client = createClient('/rest/operator-api/onboarding/templates');

export const onboardingPermissions = {
  SEARCH: 'cpms.search-onboarding-templates',
  GET: 'cpms.get-onboarding-template',
  SEARCH_CHARGING_STATIONS: 'cpms.search-onboarding-charging-stations',
  CREATE: 'cpms.create-onboarding-template',
  UPDATE: 'cpms.update-onboarding-template',
  DELETE: 'cpms.delete-onboarding-template',
  ADD_CHARGING_STATION_TO_TEMPLATE: 'cpms.add-charging-stations-to-onboarding-template',
  REMOVE_CHARGING_STATION_FROM_TEMPLATE: 'cpms.remove-charging-stations-from-onboarding-template',
  GET_CONFIGURATION: 'cpms.get-onboarding-template-configuration',
  ADD_CONFIGURATION: 'cpms.add-configuration-to-onboarding-template',
  REMOVE_CONFIGURATION: 'cpms.remove-configuration-from-onboarding-template',
  UPDATE_CONFIGURATION: 'cpms.update-configuration-in-onboarding-template'
};

export const searchOnboardingTemplates: SearchOperation<OnboardingTemplate> = searchRequestFactory<OnboardingTemplate>(
  client,
  {
    permissionId: onboardingPermissions.SEARCH
  }
);

export const getOnboardingTemplate: FindOperation<OnboardingTemplate, string> = getRequestFactory<
  OnboardingTemplate,
  string
>(client, {
  pattern: '/{id}',
  permissionId: onboardingPermissions.GET
});

export const createOnboardingTemplate: SaveOperation<CreateOnboardingTemplate, OnboardingTemplate> = postRequestFactory<
  CreateOnboardingTemplate,
  OnboardingTemplate
>(client, {
  pattern: '',
  permissionId: onboardingPermissions.CREATE
});

export const updateOnboardingTemplate: SaveOperation<UpdateOnboardingTemplate, OnboardingTemplate> = putRequestFactory<
  UpdateOnboardingTemplate,
  OnboardingTemplate
>(client, {
  pattern: '/{id}',
  permissionId: onboardingPermissions.UPDATE
});

export const removeOnboardingTemplate: DeleteOperation<void, string> = deleteRequestFactory<void, string>(client, {
  pattern: '/{id}',
  permissionId: onboardingPermissions.DELETE
});

export const getOnboardingTemplateChargingStations: SearchOperation<OnboardingChargingStation> =
  searchRequestFactory<OnboardingChargingStation>(client, {
    pattern: '/{id}/charging-stations',
    permissionId: onboardingPermissions.SEARCH_CHARGING_STATIONS
  });

export const removeChargingStationFromOnboardingTemplate: SaveOperation<UpdateChargingStationFromTemplate, void> =
  postRequestFactory<UpdateChargingStationFromTemplate, void>(client, {
    pattern: '/{id}/remove-charging-stations',
    permissionId: onboardingPermissions.REMOVE_CHARGING_STATION_FROM_TEMPLATE
  });

export const addChargingStationFromOnboardingTemplate: SaveOperation<UpdateChargingStationFromTemplate, void> =
  postRequestFactory<UpdateChargingStationFromTemplate, void>(client, {
    pattern: '/{id}/add-charging-stations',
    permissionId: onboardingPermissions.ADD_CHARGING_STATION_TO_TEMPLATE
  });

export const addConfigurationToOnboardingTemplate: SaveOperation<OnboardingConfiguration, void> = postRequestFactory<
  OnboardingConfiguration,
  void
>(client, {
  pattern: '/{id}/add-configuration',
  permissionId: onboardingPermissions.ADD_CONFIGURATION
});

export const removeConfigurationFromOnboardingTemplate: SaveOperation<DeleteOnboardingConfiguration, void> =
  postRequestFactory<DeleteOnboardingConfiguration, void>(client, {
    pattern: '/{id}/remove-configuration',
    permissionId: onboardingPermissions.REMOVE_CONFIGURATION
  });

export const updateConfigurationOfOnboardingTemplate: SaveOperation<OnboardingConfiguration, void> = postRequestFactory<
  OnboardingConfiguration,
  void
>(client, {
  pattern: '/{id}/update-configuration',
  permissionId: onboardingPermissions.UPDATE_CONFIGURATION
});

export const getOnboardingTemplateConfiguration: FindOperation<ComponentGroup> = getRequestFactory<ComponentGroup>(
  client,
  {
    pattern: '/{id}/configuration',
    permissionId: onboardingPermissions.GET_CONFIGURATION
  }
);
